import util from '../util';

export const PENCIL_LIST = 'PENCIL_LIST';
export const PENCIL_LIST_CANCELLED = 'PENCIL_LIST_CANCELLED';

export const REMOVE_EXPIRED_INCENTIVES = 'REMOVE_EXPIRED_INCENTIVES';
export const REMOVE_UNAVAILABLE_ACCESSORIES = 'REMOVE_UNAVAILABLE_ACCESSORIES';

export const PENCIL_LIST_REQUEST = util.requestType(PENCIL_LIST);
export const PENCIL_LIST_SUCCESS = util.successType(PENCIL_LIST);
export const PENCIL_LIST_FAILURE = util.failureType(PENCIL_LIST);
export const PENCIL_LIST_RESET = util.resetType(PENCIL_LIST);
export const PENCIL_LIST_POLLING_RESET = util.resetType(PENCIL_LIST);
export const PENCIL_LIST_POLLING_CANCELLED_EVENT = util.eventType(
  PENCIL_LIST_CANCELLED,
);

export const REMOVE_EXPIRED_INCENTIVES_REQUEST = util.requestType(
  REMOVE_EXPIRED_INCENTIVES,
);
export const REMOVE_UNAVAILABLE_ACCESSORIES_REQUEST = util.requestType(
  REMOVE_UNAVAILABLE_ACCESSORIES,
);
